module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true,
        "fullscreen": true
      }
    }],
    attrs: {
      "id": "app",
      "element-loading-text": "加载中...",
      "element-loading-customClass": "loading"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a99b69b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1177
// module chunks = 2